import { AppDispatch, store } from "utils/redux/store";
import {
  setIsCoachbotOpen,
  setCoachBotPrompt,
  setSampleChatState,
  setChatbotFullScreen,
  selectChatbotConversationEntities,
  getCoachBoConversations,
  selectThreadId,
  setChatbotMessages,
} from "app/containers/Chatbot/slice";
import { setIsQuickActionDrawerOpen } from "./slice";

export const onSampleWeeklyCheckInClick = async (
  name: string,
  dispatch: AppDispatch,
  options?: {
    openFloatingChatbot?: boolean;
    setFullScreen?: boolean;
  }
) => {
  if (options?.openFloatingChatbot) {
    dispatch(setIsCoachbotOpen(true));
  }
  dispatch(
    setSampleChatState({
      isSampleChatShowing: true,
      isCheckingSampleChat: true,
    })
  );

  await dispatch(
    setCoachBotPrompt({
      chatType: "weeklyCheckIn",
      userPrompts: [
        "Explore how chatting together regularly can help",
        "Envision my ideal future",
        "Create a 1-2 month growth goal",
      ],
      isSampleChat: true,
    })
  );

  await dispatch(getCoachBoConversations({ refresh: true }));

  const storeState = store.getState();
  const threadId = selectThreadId(storeState);

  const savedChatbotConversations =
    selectChatbotConversationEntities(storeState);

  const savedConversation = threadId && savedChatbotConversations[threadId];
  const messages = savedConversation
    ? savedConversation.messages
    : [
        {
          content: `Hi ${name}, let's take a quick moment to reflect on how things have been going. As a reminder, I'll be sharing key themes with your team leader(s) to help them support you and the team better.`,
          role: "assistant" as const,
        },
        {
          content: "How are you feeling about things lately?",
          role: "assistant" as const,
        },
      ];
  dispatch(setChatbotMessages(messages));
  dispatch(setChatbotFullScreen(true));
  dispatch(setIsQuickActionDrawerOpen(false));
};
